import React, { useEffect, useState, useRef } from "react";
import Excalidraw, {
  exportToCanvas,
  exportToSvg,
  exportToBlob
} from "@excalidraw/excalidraw";
import type { ExcalidrawImperativeAPI } from "@excalidraw/excalidraw/types/types";


import "./styles.scss";

import type { ExcalidrawElement } from "@excalidraw/excalidraw/types/element/types";
import {
  AppState,
  ExcalidrawProps,
  SceneData
} from "@excalidraw/excalidraw/types/types";

import InitialData from "./initialData";

const renderTopRightUI = () => (
  <button type="button" onClick={() => alert("This is dummy top right UI")}>
    {" "}
    Click me{" "}
  </button>
);

const renderFooter = () => (
  <button type="button" onClick={() => alert("This is dummy footer")}>
    {" "}
    custom footer{" "}
  </button>
);

const initialData = InitialData;

export function Draw() {
  const excalidrawRef = useRef<ExcalidrawImperativeAPI>(null);

  const [viewModeEnabled, setViewModeEnabled] = useState(false);
  const [zenModeEnabled, setZenModeEnabled] = useState(false);
  const [gridModeEnabled, setGridModeEnabled] = useState(false);
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [canvasUrl, setCanvasUrl] = useState<string | null>(null);
  const [exportWithDarkMode, setExportWithDarkMode] = useState<boolean>(false);
  const [shouldAddWatermark, setShouldAddWatermark] = useState<boolean>(false);
  const [theme, setTheme] = useState<ExcalidrawProps["theme"]>("light");

  useEffect(() => {
    const onHashChange = () => {
      const hash = new URLSearchParams(window.location.hash.slice(1));
      const libraryUrl = hash.get("addLibrary");
      if (libraryUrl) {
        excalidrawRef.current!.importLibrary(libraryUrl, hash.get("token"));
      }
    };
    window.addEventListener("hashchange", onHashChange, false);
    return () => {
      window.removeEventListener("hashchange", onHashChange);
    };
  }, []);

  const updateScene = () => {
    // const sceneData: SceneData = {
    //   elements: [
    //     {
    //       type: "rectangle",
    //       version: 141,
    //       versionNonce: 361174001,
    //       isDeleted: false,
    //       id: "oDVXy8D6rom3H1-LLH2-f",
    //       fillStyle: "hachure",
    //       strokeWidth: 1,
    //       strokeStyle: "solid",
    //       roughness: 1,
    //       opacity: 100,
    //       angle: 0,
    //       x: 100.50390625,
    //       y: 93.67578125,
    //       strokeColor: "#c92a2a",
    //       backgroundColor: "transparent",
    //       width: 186.47265625,
    //       height: 141.9765625,
    //       seed: 1968410350,
    //       groupIds: [],
    //       strokeSharpness: "round",
    //       boundElementIds: null
    //     }
    //   ],
    //   appState: { viewBackgroundColor: "transparent", currentItemFontFamily: 1 },
    // };
    // excalidrawRef.current!.updateScene(sceneData);
  };

  return (
    <div className="App">
      {/* <h1> Excalidraw Example</h1> */}
      <div className="button-wrapper">
        {/* <button
          type="button"
          className="primary-btn"
          onClick={updateScene}
        >
          Update Scene
        </button> */}
        <button
          type="button"
          className="primary-btn"
          onClick={() => {
            excalidrawRef.current!.resetScene();
          }}
        >
          Reset Scene
        </button>

        {/* <label>
          <div className="checkbox">
            <input
              type="checkbox"
              checked={viewModeEnabled}
              onChange={() => setViewModeEnabled(!viewModeEnabled)}
            />
            <i className="checkbox-ico" />
            View mode
          </div>
        </label>

        <label>
          <div className="checkbox">
            <input
              type="checkbox"
              checked={zenModeEnabled}
              onChange={() => setZenModeEnabled(!zenModeEnabled)}
            />
            <i className="checkbox-ico" />
            Zen mode
          </div>
        </label>

        <label>
          <div className="checkbox">
            <input
              type="checkbox"
              checked={gridModeEnabled}
              onChange={() => setGridModeEnabled(!gridModeEnabled)}
            />
            <i className="checkbox-ico" />
            Grid mode
          </div>
        </label>

        <label>
          <div className="checkbox">
            <input
              type="checkbox"
              checked={theme === "dark"}
              onChange={() => {
                let newTheme: "light" | "dark" = "light";
                if (theme === "light") {
                  newTheme = "dark";
                }
                setTheme(newTheme);
              }}
            />
            <i className="checkbox-ico" />
            Switch to Dark Theme
          </div>
        </label> */}
      </div>

      <div className="excalidraw-wrapper" style={{ position: 'relative' }}>
        <img src='/account/img/bg.png' alt="" style={{ position: 'absolute', top: 100, marginRight: 5 }} />
        <Excalidraw
          ref={excalidrawRef}
          initialData={InitialData}
          // onChange={(elements: readonly ExcalidrawElement[], state: AppState) =>
          //   console.log("Elements :", elements, "State : ", state)
          // }
          // onPointerUpdate={(payload) => console.log(payload)}
          // onCollabButtonClick={() =>
          //   window.alert("You clicked on collab button")
          // }
          viewModeEnabled={viewModeEnabled}
          zenModeEnabled={zenModeEnabled}
          gridModeEnabled={gridModeEnabled}
          theme={theme}
          name="Custom name of drawing"
          // renderFooter={renderFooter}
          // renderTopRightUI={renderTopRightUI}
        />
      </div>

      <div className="row form-group">
        {/*
        <div className="col-lg-3">
          <div className="checkbox">
            <input
              type="checkbox"
              checked={exportWithDarkMode}
              onChange={() => setExportWithDarkMode(!exportWithDarkMode)}
            />
            <i className="checkbox-ico" />
            Export with dark mode
          </div>
        </div>
        <div className="col-lg-2">
          <div className="checkbox">
            <input
              type="checkbox"
              checked={shouldAddWatermark}
              onChange={() => setShouldAddWatermark(!shouldAddWatermark)}
            />
            <i className="checkbox-ico" />
            Add Watermark
          </div>
        </div>
      </div>

      <div className="row form-group button-wrapper">
        <button
          className="primary-btn"
          type="button"
          onClick={async () => {
            const svg = await exportToSvg({
              elements: excalidrawRef.current!.getSceneElements(),
              appState: {
                ...initialData.appState,
                exportWithDarkMode,
                // shouldAddWatermark
              }
            });
            document.querySelector(".export-svg")!.innerHTML = svg.outerHTML;
          }}
        >
          Export to SVG
        </button>


        <button
          type="button"
          className="primary-btn"
          onClick={async () => {
            const blob = await exportToBlob({
              elements: excalidrawRef.current!.getSceneElements(),
              mimeType: "image/png",
              appState: {
                ...initialData.appState,
                exportWithDarkMode,
                // shouldAddWatermark
              }
            });
            setBlobUrl(window.URL.createObjectURL(blob));
          }}
        >
          Export to Blob
        </button>
        */}

        <button
          type="button"
          className="primary-btn"
          onClick={() => {
            const canvas = exportToCanvas({
              elements: excalidrawRef.current!.getSceneElements(),
              appState: {
                ...initialData.appState,
                exportWithDarkMode,
                // shouldAddWatermark
              }
            });
            setCanvasUrl(canvas.toDataURL());
          }}
        >
          Export to Canvas
        </button>
      </div>
      <div className="row form-group button-wrapper">
        <div className="col-lg-12">
          <div className="export export-svg" />

          <div className="export export-blob">
            <img src={blobUrl!} alt="" />
          </div>

          <div className="export export-canvas">
            <img src={canvasUrl!} alt="" />
          </div>
        </div>
      </div>

    </div>
  );
}
